module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_16.1263393c.png";